import { render, staticRenderFns } from "./StepOtp.vue?vue&type=template&id=7a89059e&scoped=true"
import script from "./StepOtp.vue?vue&type=script&lang=js"
export * from "./StepOtp.vue?vue&type=script&lang=js"
import style0 from "./StepOtp.vue?vue&type=style&index=0&id=7a89059e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a89059e",
  null
  
)

export default component.exports